import { hasPrototype } from 'application-frame/util/make';

const Transition = function(element, options = {}) {
    const transition = Object.create(TransitionPrototype).constructor(element, options);

    return transition;
};

const TransitionPrototype = {

    element: null,

    constructor(element, options) {
        this.element = element;

        this._promise = new Promise((done) => {
            const callback = (event) => {
                if (options.target) {
                    // try to compare node name
                    if (typeof options.target === 'string' &&
                        event.target.nodeName === options.target.toUpperCase()) {
                        return;
                    }

                    // try to compare as actual node
                    if (hasPrototype(options.target, Element) &&
                        options.target !== event.target) {
                        return;
                    }
                }

                if (options.propertyName && options.propertyName !== event.propertyName) {
                    return;
                }

                this.element.removeEventListener('transitionend', callback);
                done(event);
            };
            this.element.addEventListener('transitionend', callback);
        });

        return this;
    },

    add(...classNames) {
        this.element.classList.add(...classNames);

        return this;
    },

    remove(...classNames) {
        this.element.classList.remove(...classNames);

        return this;
    },

    then(...args) {
        return this._promise.then(...args);
    },

    'catch'(...args) {
        return this._promise.catch(...args);
    }
};

export default Transition;



//////////////////
// WEBPACK FOOTER
// ./rendering/Transition.js
// module id = 57
// module chunks = 0